
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/guild/signup/create-account",
      function () {
        return require("private-next-pages/[locale]/guild/signup/create-account/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/guild/signup/create-account"])
      });
    }
  